import * as Raven from "raven-js";
import * as React from "react";
import { connect } from "react-redux";
import { Users } from "../../../just-in-types";
import {
  SetUserValue,
  setUserValue,
  toggleCamera,
  ToggleCamera,
} from "../store/actions";
import { IState } from "../store/reducers";

interface ICameraDispatchProps {
  onSetUserValue: SetUserValue;
  onToggleCamera: ToggleCamera;
}

interface ICameraStateProps {
  businessId: string;
  mounted: boolean;
}

type CameraProps = ICameraDispatchProps & ICameraStateProps;

interface ICameraState {
  mugshot: null | string;
}

const oneByOne =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

class Camera extends React.Component<CameraProps, ICameraState> {
  private initialState = { mugshot: null };
  private constraints = { audio: false, video: { width: 400, height: 400 } };
  private stream: null | MediaStream = null;
  private video: null | HTMLVideoElement = null;

  constructor(props: CameraProps) {
    super(props);

    this.state = this.initialState;
  }

  public componentDidMount() {
    const { mounted } = this.props;

    if (mounted) {
      this.initializeCamera();
    }
  }

  public componentDidUpdate({ mounted: prevMounted }: ICameraStateProps) {
    const { mounted } = this.props;

    if (prevMounted !== mounted) {
      if (prevMounted === false && mounted === true) {
        this.initializeCamera();
      }

      if (prevMounted === true && mounted === false) {
        this.setState(this.initialState);
      }
    }
  }

  public componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  public componentWillUnmount() {
    if (this.video) {
      this.video.pause();
    }
    if (this.stream) {
      this.stream.stop();
    }
  }

  public render() {
    const { mounted } = this.props;

    if (mounted) {
      return (
        <div style={{ opacity: 0 }}>
          <video ref={(ref) => ref && (this.video = ref)} />
        </div>
      );
    } else {
      return null;
    }
  }

  private handleError = (error: any) => {
    const { onSetUserValue, onToggleCamera } = this.props;

    onSetUserValue({ name: "mugshot", value: oneByOne });

    Raven.captureException(JSON.stringify(error));

    onToggleCamera(false);
  };

  private initializeCamera = async () => {
    if (
      this.video &&
      "mediaDevices" in navigator &&
      "getUserMedia" in navigator.mediaDevices
    ) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia(
          this.constraints
        );
        this.stream = stream;

        this.video.srcObject = stream;

        this.video.addEventListener("loadeddata", this.takeMugshot);
      } catch (error) {
        this.handleError(error);
      }
    } else if ("getUserMedia" in navigator) {
      navigator.getUserMedia(
        this.constraints,
        (stream) => {
          if (this.video) {
            this.video.srcObject = stream;

            this.video.addEventListener("loadeddata", this.takeMugshot);
          }
        },
        (error: any) => this.handleError(error)
      );
    } else {
      this.handleError(
        '"mediaDevices" and "getUserMedia" not found in navigator. Likely an older browser or lack of permission.'
      );
    }
  };

  private stopTracks = () => {
    if (this.stream) {
      for (const track of this.stream.getTracks()) {
        track.stop();
      }
    }

    if (this.video) {
      this.video.pause();
    }
  };

  private takeMugshot = async () => {
    try {
      const { businessId, onSetUserValue, onToggleCamera } = this.props;
      const { width, height } = this.constraints.video;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;

      if (businessId === "9RUee7l0TVRUaMrnUcPl") {
        // All-pro needs us to flip their image, as their camera takes it upside down.
        // these next two lines flip the picture on it's horizontal axis
        context.translate(0, canvas.height);
        context.scale(1, -1);
      }

      if (context && this.video) {
        await this.video.play();

        context.drawImage(this.video, 0, 0, width, height);
      }

      const data = canvas.toDataURL("image/jpeg", 0.3);

      console.log("picture taken");
      this.setState({ mugshot: data }, () => {
        onSetUserValue({ name: "mugshot", value: data });

        this.stopTracks();

        onToggleCamera(false);
      });
    } catch (error) {
      this.handleError(error);
    }
  };
}

const mapStateToProps = ({
  camera: { mounted },
  router: { businessId },
}: IState) => ({ businessId, mounted });

const mapDispatchToProps = {
  onSetUserValue: setUserValue,
  onToggleCamera: toggleCamera,
};

export default connect<any, ICameraDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps
)(Camera);



// WEBPACK FOOTER //
// ./src/components/Camera.tsx